import { Grid, useTheme } from "@mui/material";
import { blue, cyan } from "@mui/material/colors";
import BarChartPlotly from "components/charts/BarChartPlotly.component";
import HorizontalBarChartPlotly from "components/charts/HorizontalBarChart.component";
import LineChartPlotly from "components/charts/LineChartPlotly.component";
import React, { Fragment, useEffect, useState } from "react";
import {
  getMinMaxLineChart,
} from "constants/charts";
import _ from "lodash";
import {
  getTimeZoneStandard, getTimeZoneStandardInteger,
} from "utils/timezone";
import AdvancedMetricCard from "components/cards/metrics/AdvancedMetricCard.component";
import RadarChartPlotly from "components/charts/RadarChart.component";
import Force from "assets/images/Force.png";
import { useTranslation } from "react-i18next";
import { WIND_DIRECTION_DICT360, getIconWindDirection, getWindForce } from "constants/wind";

const WindMetriContainer = ({
  data,
  dataDouble,
  children,
  viewHorChart,
  viewBarChart = true,
}) => {
  const { t } = useTranslation()
  const theme = useTheme();
  const [dataLineChart, setDataLineChart] = useState([]);
  const [zoneMean, setZoneMean] = useState(null);
  const [meanHours, setMeanHours] = useState(null);
  const [dataLineDir, setDataLineDir] = useState(null);
  const [dataRadar, setDataRadar] = useState(null);
  const [time, setTime] = useState(null);
  const [doubleTime, setDoubleTime] = useState(null);
  const [trace1, setTrace1] = useState(null);
  const [trace2, setTrace2] = useState(null);

  useEffect(() => {
    if (data && !_.isEmpty(data) && data?.time && !_.isEmpty(data?.time)) {
      const newTime = [];
      data?.time?.map((item) => {
        return newTime.push(getTimeZoneStandard(item));
      });

      setTime(newTime);
    }

    if (data && data?.avg) {
      const obj = {};
      if (data?.avg?.min !== null) {
        if (data?.avg?.min === 0) {
          obj.min = 0;
        } else {
          obj.min = data?.avg?.min;
        }
      } else if (data?.avg?.min?.isNaN()) obj.min = null;

      if (data?.avg?.max !== null) {
        if (data?.avg?.max === 0) {
          obj.max = 0;
        } else {
          obj.max = data?.avg?.max;
        }
      } else if (data?.avg?.max?.isNaN()) obj.max = null;

      if (data?.avg?.mean !== null) {
        if (data?.avg?.mean === 0) {
          obj.mean = 0;
        } else {
          obj.mean = data?.avg?.mean;
        }
      } else if (data?.avg?.mean?.isNaN()) obj.mean = null;
      setTrace1(obj);
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (dataDouble && dataDouble?.avg) {
      const obj = {};
      if (dataDouble?.avg?.min !== null) {
        if (dataDouble?.avg?.min === 0) {
          obj.min = 0;
        } else {
          obj.min = dataDouble?.avg?.min;
        }
      } else if (dataDouble?.avg?.min?.isNaN()) obj.min = null;
      if (dataDouble?.avg?.max !== null) {
        if (dataDouble?.avg?.max === 0) {
          obj.max = 0;
        } else {
          obj.max = dataDouble?.avg?.max;
        }
      } else if (dataDouble?.avg?.max?.isNaN()) obj.max = null;
      if (dataDouble?.avg?.mean !== null) {

        if (dataDouble?.avg?.mean === 0) {
          obj.mean = 0;
        } else {
          obj.mean = dataDouble?.avg?.mean;
        }
      } else if (dataDouble?.avg?.mean?.isNaN()) obj.mean = null;
      setTrace2(obj);
    }
    // eslint-disable-next-line
  }, [dataDouble?.avg]);

  useEffect(() => {
    if (
      dataDouble &&
      !_.isEmpty(dataDouble) &&
      dataDouble?.time &&
      !_.isEmpty(dataDouble?.time)
    ) {
      const newTime = [];
      dataDouble?.time?.map((item) => {
        return newTime.push(getTimeZoneStandard(item));
      });

      setDoubleTime(newTime);
    }
  }, [dataDouble]);

  useEffect(() => {
    if (data?.hourly) {
      const newTime = [];
      data?.hourly?.hour?.map((item) => {
        return newTime.push(getTimeZoneStandardInteger(item));
      });

      const trace = {
        x: newTime,
        y: data?.hourly?.data,
        name: "Media oraria",
        marker: { color: cyan[600] },
        type: "bar",
      };
      setMeanHours([trace]);
    }

    if (data?.by_cluster) {
      const trace = {
        x: data?.by_cluster?.data,
        y: data?.by_cluster?.cluster,
        name: "Zone",
        orientation: "h",
        marker: { color: cyan[600], width: 0.5 },
        type: "bar",
      };
      setZoneMean([trace]);
    }

    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    let traceChart = [];

    if (data?.avg?.data_min && time) {
      const dataLine = {
        x:
          !_.isEmpty(time) && !_.isEmpty(data?.avg?.data_min)
            ? time.filter((item, index) => data?.avg?.data_min[index] !== null)
            : [],
        y:
          !_.isEmpty(data?.avg?.data_min) &&
            data?.avg?.data_min.filter((item) => item !== null).length !== 0
            ? data?.avg?.data_min.filter((item) => item !== null)
            : [],
        textfont: { color: theme.palette.mode === "dark" ? "white" : "black" },
        fillcolor: `${cyan[800]}33`,
        line: { color: cyan[800], width: 0 },
        type: "scatter",
        name: "Min",
        showlegend: false,
      };
      traceChart.push(dataLine);
    }

    if (data?.avg?.data) {
      const trace1 = {
        // x: time,
        // y: data?.avg?.data,
        x:
          !_.isEmpty(time) && !_.isEmpty(data?.avg?.data)
            ? time.filter((item, index) => data?.avg?.data[index] !== null)
            : [],
        y:
          !_.isEmpty(data?.avg?.data) &&
            data?.avg?.data?.filter((item) => item !== null).length !== 0
            ? data?.avg?.data?.filter((item) => item !== null)
            : [],
        textfont: { color: "black" },
        mode: "lines",
        type: "scatter",
        name: t('Speed'),
        line: { dash: "dot", color: cyan[900], width: 0.9 },
        fill: "tonexty",
        fillcolor: `${cyan[800]}33`,
      };
      if (dataDouble?.avg?.data_idx) {
        const text = [];
        dataDouble?.avg?.data_idx.map((item, index) => {
          if (data?.avg?.data[index] !== null)
            return text.push(getIconWindDirection(item));
          return null;
        });

        const trace2 = {
          x:
            !_.isEmpty(time) && !_.isEmpty(data?.avg?.data)
              ? time.filter((item, index) => data?.avg?.data[index] !== null)
              : [],
          y:
            !_.isEmpty(data?.avg?.data) &&
              data?.avg?.data?.filter((item) => item !== null).length !== 0
              ? data?.avg?.data?.filter((item) => item !== null)
              : [],
          mode: "lines+text",
          text: text,
          type: "scatter",
          textfont: {
            size: 19,
            color: cyan[900],
            width: 0.2,
          },
          line: { width: 0 },
          name: "",
        };

        traceChart.push(trace1);
        traceChart.push(trace2);
      }
    }

    if (data?.avg?.data_max && time) {
      const dataLine = {
        x:
          !_.isEmpty(time) && !_.isEmpty(data?.avg?.data_max)
            ? time.filter((item, index) => data?.avg?.data_max[index] !== null)
            : [],
        y:
          !_.isEmpty(data?.avg?.data_max) &&
            data?.avg?.data_max.filter((item) => item !== null).length !== 0
            ? data?.avg?.data_max.filter((item) => item !== null)
            : [],
        textfont: { color: theme.palette.mode === "dark" ? "white" : "black" },
        fillcolor: `${cyan[800]}33`,
        line: { color: cyan[800], width: 0 },
        name: "Max",
        fill: "tonexty",
        type: "scatter",
        showlegend: false,
      };
      traceChart.push(dataLine);
    }
    setDataLineChart(traceChart);
  }, [data, dataDouble, time, theme, t]);

  useEffect(() => {
    let traceChart = [];
    if (dataDouble?.avg?.data && doubleTime) {
      const trace = {
        x:
          !_.isEmpty(doubleTime) && !_.isEmpty(dataDouble?.avg?.data)
            ? doubleTime.filter(
              (item, index) => dataDouble?.avg?.data[index] !== null
            )
            : [],
        y:
          !_.isEmpty(dataDouble?.avg?.data) &&
            dataDouble?.avg?.data?.filter((item) => item !== null).length !== 0
            ? dataDouble?.avg?.data?.filter((item) => item !== null)
            : [],
        mode: "lines",
        type: "scatter",
        fill: "tonexty",
        name: t('Direction'),
        fillcolor: `${cyan[800]}33`,
        line: { color: cyan[800], width: 1.5 },
      };

      traceChart.push(trace);

      const traceE = {
        x: [doubleTime[0], doubleTime[doubleTime.length - 1]],
        y: [90, 90],
        mode: "lines+text",
        name: "",
        text: ["E "],
        textposition: "left",
        type: "scatter",
        line: { color: blue[900], width: 1 },
        textfont: {
          size: 14,
          color: blue[900],
        },
      };

      const traceS = {
        x: [doubleTime[0], doubleTime[doubleTime.length - 1]],
        y: [180, 180],
        mode: "lines+text",
        name: "",
        text: ["S "],
        textposition: "left",
        type: "scatter",
        line: { color: blue[900], width: 1 },
        textfont: {
          size: 14,
          color: blue[900],
        },
      };

      const traceW = {
        x: [doubleTime[0], doubleTime[doubleTime.length - 1]],
        y: [270, 270],
        mode: "lines+text",
        name: '',
        text: [`${t('W')}`],
        textposition: "left",
        type: "scatter",
        line: { color: blue[900], width: 1 },
        textfont: {
          size: 14,
          color: blue[900],
        },
      };

      const traceN = {
        x: [doubleTime[0], doubleTime[doubleTime.length - 1]],
        y: [360, 360],
        mode: "lines+text",
        name: '',
        text: ["N "],
        textposition: "left",
        type: "scatter",
        line: { color: blue[900], width: 1 },
        textfont: {
          size: 14,
          color: blue[900],
        },
      };
      traceChart.push(traceE);
      traceChart.push(traceS);
      traceChart.push(traceW);
      traceChart.push(traceN);
    }

    setDataLineDir(traceChart);

    if (dataDouble?.avg?.data) {
      const frequence = [
        dataDouble?.avg?.data?.filter((item) => item === 0).length,
        dataDouble?.avg?.data?.filter((item) => item === 22.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 45).length,
        dataDouble?.avg?.data?.filter((item) => item === 67.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 90).length,
        dataDouble?.avg?.data?.filter((item) => item === 112.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 135).length,
        dataDouble?.avg?.data?.filter((item) => item === 175.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 180).length,
        dataDouble?.avg?.data?.filter((item) => item === 202.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 225).length,
        dataDouble?.avg?.data?.filter((item) => item === 247.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 270).length,
        dataDouble?.avg?.data?.filter((item) => item === 292.5).length,
        dataDouble?.avg?.data?.filter((item) => item === 315).length,
        dataDouble?.avg?.data?.filter((item) => item === 337.5).length,
      ];

      setDataRadar([
        {
          r: frequence,
          theta: [
            "N",
            "NNE",
            "NE",
            "ENE",
            "E",
            "ESE",
            "SE",
            "SSE",
            "S",
            t('SSW'),
            t('SW'),
            t('WSW'),
            t('W'),
            t("WNW"),
            t('NW'),
            t('NNW'),
          ],

          marker: { color: cyan[700] },
          type: "barpolar",
        },
      ]);
    }
    // eslint-disable-next-line
  }, [dataDouble, theme, doubleTime, t]);

  return (
    <Fragment>
      {data && dataDouble && (
        <Grid container spacing={3}>
          <Grid item xs={12} />
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            lg={1.5}
            container
            spacing={3}
            sx={{ maxHeight: 180 }}
          >
            {trace1 && trace1.mean !== undefined && (
              <Grid item xs={6} sm={12} md={12} lg={12}>
                <AdvancedMetricCard
                  label={t('Average speed')}
                  value={
                    trace1 === null ||
                      trace1?.mean === 0 ||
                      trace1?.mean === null
                      ? t('absent-wind')
                      : `${trace1.mean} km/h`
                  }
                  icon={
                    trace1 === null || trace1?.mean === null
                      ? getWindForce(0)
                      : getWindForce(trace1?.mean)
                  }
                />
              </Grid>
            )}
            {trace2 && trace2?.mean !== undefined && (
              <Grid item xs={6} sm={12} md={12} lg={12}>
                <AdvancedMetricCard
                  label={t('Average direction')}
                  value={
                    trace1?.mean === 0 ||
                      trace2?.mean === null ||
                      trace2 === null
                      ? t('absent-wind')
                      : `${t(WIND_DIRECTION_DICT360[trace2.mean])}`
                  }
                  icon={<img width={20} src={Force} alt="img wind force" />}
                />
              </Grid>
            )}
          </Grid>

          {!_.isEmpty(dataDouble?.avg?.data) &&
            !_.isEmpty(dataDouble?.avg?.data?.filter((item) => item !== null)) && (
              <Grid item xs={12} sm={10} md={10} lg={10.5}>
                <LineChartPlotly
                  titleChart={t('Wind speed and direction')}
                  yLabel={`${t('Speed')} (km/h)`}
                  data={dataLineChart}
                  showlegend={false}
                  xRange={time && [time[0], time[time.length - 1]]}
                />
              </Grid>
            )}

          {!_.isEmpty(dataDouble?.avg?.data) &&
            !_.isEmpty(dataDouble?.avg?.data?.filter((item) => item !== null)) && (
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <RadarChartPlotly data={dataRadar} height={260} />
              </Grid>
            )}

          {!_.isEmpty(dataDouble?.avg?.data) &&
            !_.isEmpty(dataDouble?.avg?.data?.filter((item) => item !== null)) && (
              <Grid item xs={12} sm={12} md={8} lg={8}>
                <LineChartPlotly
                  yLabel={`${t('Direction')} (360°)`}
                  data={dataLineDir}
                  showlegend={false}
                  yRange={[0, 375]}
                  yVisible={false}
                />
              </Grid>
            )}

          <Grid item container spacing={3} xs={12} display='flex' alignItems='center'>
            {viewHorChart && !_.isEmpty(data?.by_cluster?.data)
              && !_.isEmpty(data?.by_cluster?.data?.filter((item) => item !== null))
              && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <HorizontalBarChartPlotly
                    data={zoneMean}
                    xLabel={`${t('Speed')} (km/h)`}
                    xRange={getMinMaxLineChart(trace1?.min, trace1?.max)}
                  // height={312}
                  />
                </Grid>
              )}

            {viewBarChart && !_.isEmpty(data?.hourly?.data)
              && !_.isEmpty(data?.hourly?.data?.filter((item) => item !== null))
              && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <BarChartPlotly
                    data={meanHours}
                    yLabel={`${t('Speed')} (km/h)`}
                    xLabel={t('hour')}
                    yRange={getMinMaxLineChart(trace1?.min, trace1?.max)}
                  />
                </Grid>
              )}
            {children && (
              <Grid item xs={12} sm={12}
                md={((!viewBarChart && !viewHorChart) || (viewBarChart && viewHorChart)) ? 12 : 6}
                lg={((!viewBarChart && !viewHorChart) || (viewBarChart && viewHorChart)) ? 12 : 6}
              >
                {children}
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
};

export default WindMetriContainer;
